import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Calendar from 'react-calendar/dist/entry.nostyle'

import './style'

import { colors, media } from '../../constants/style'
import { convertDate, getEventsGroupped, pad } from '../../utils'

import { Column, Row } from '../UI/Grid'

import CalendarPreview from './CalendarPreview'


const Wrapper = Column.extend`
  ${media.medium`
    padding: 40px 20px;
  `}
`

const Inner = Row.extend`
  padding: 30px 10px;
  flex-wrap: wrap;
  ${media.medium`
    padding: 30px;
    border: 2px solid ${colors.red};
  `}
`

const Events = Column.extend`
  padding: 10px;
  ${media.medium`
    padding: 20px 40px 0;
  `}
`

const ColumnCalendar = Column.extend`
  width: 100%;
  margin: 0 auto;
  ${media.large`
    flex-basis: 500px;
  `}
`

const ColumnCalendarInfo = Column.extend`
  flex-basis: 100%;
  ${media.wide`
    flex-basis: calc( 100% - 500px );
  `}
`

const PrevLabel = () => (
  <svg width="26" height="51" viewBox="0 0 26 51" fill="none">
    <path d="M25.3933 50.2475L0.368408 25.042L25.3933 0.0045166V50.2475Z" fill="#D72027"/>
  </svg>
)

const NextLabel = () => (
  <svg width="26" height="51" viewBox="0 0 26 51" fill="none">
    <path d="M0.591064 0.0045166L25.616 25.042L0.591064 50.2475V0.0045166Z" fill="#D72027"/>
  </svg>
)

class CalendarSection extends Component {
  state = {
    events: getEventsGroupped(this.props.data),
    date: new Date(),
  }

  onChange = date => this.setState({ date })

  getTileClassName = ({ date }) => {
    const { events } = this.state

    const dates = Object.keys(events).reduce((_, eventDate) => [
      ..._,
      {
        date: new Date(convertDate(eventDate)),
        gray: events[eventDate].gray,
      }
    ], [])

    const filteredDates = dates.filter(({ date: eventDate }) => eventDate.getTime() === date.getTime())

    if (filteredDates.length === 0) return 'customTile'

    const hasEventRed = !!filteredDates.filter(({ gray }) => !gray).length
    const hasEventGray = !!filteredDates.filter(({ gray }) => gray).length

    if (hasEventRed && hasEventGray) return 'customTile customTile--hasEvent customTile--hasMultipleEvent'

    if (hasEventRed) return 'customTile customTile--hasEvent customTile--hasEventRed'

    if (hasEventGray) return 'customTile customTile--hasEvent customTile--hasEventGray'

    return 'customTile'
  }

  render() {
    const { date, events } = this.state

    const currentKey = `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`

    const currentEvents = events[currentKey]

    return (
      <Wrapper>
        <Inner>
          <ColumnCalendar grow={0}>
            <Calendar
              onChange={this.onChange}
              onActiveDateChange={this.onChangeMonth}
              tileClassName={this.getTileClassName}
              prevLabel={<PrevLabel />}
              nextLabel={<NextLabel />}
              locale="it-IT"
              showNeighboringMonth={false}
            />
          </ColumnCalendar>
          <ColumnCalendarInfo grow={0}>
            <Events>
              <CalendarPreview data={currentEvents} />
            </Events>
          </ColumnCalendarInfo>
        </Inner>
      </Wrapper>
    );
  }
}

CalendarSection.propTypes = {
  data: PropTypes.array.isRequired,
}

export default CalendarSection



// WEBPACK FOOTER //
// ./src/components/Calendar/index.js